import { apiClient } from './index';
import { handleResponse, handleError } from './responseHandler';
import APIConstants from '../../constants/APIConstants';
import { getSelectedFeedlotId } from '../storageService/GlobalData';
import { globalHelper } from '../../helpers';

class RecordBinderService {
  getRecordBinders(feedlotId, lastSynced = null) {
    let url = APIConstants.GET_RECORD_BINDERS.replace(
      '{{feedlotId}}',
      feedlotId || getSelectedFeedlotId(),
    );
    
    if (lastSynced) {
      url = url.concat(`?syncCall=true&time=${lastSynced}`);
    } else {
      url = url.concat('?syncCall=false');
    }
    
    return apiClient().get(url).then(handleResponse).catch(handleError);
  }

  getRecordHistory(recordId) {
    const url = APIConstants.GET_RECORD_HISTORY.replace('{{recordId}}', recordId);
    return apiClient().get(url).then(handleResponse).catch(handleError);
  }

  getRecordHistoryDetails(id) {
    const url = APIConstants.GET_RECORD_HISTORY_DETAILS.replace('{{id}}', id);
    return apiClient().get(url).then(handleResponse).catch(handleError);
  }

  addRecord(payload) {
    const url = APIConstants.ADD_RECORD;
    return apiClient()
      .post(url, payload)
      .then(handleResponse)
      .catch(handleError);
  }

  updateRecord(id, payload) {
    const url = APIConstants.UPDATE_RECORD.replace('{{id}}', id);
    return apiClient()
      .put(url, payload)
      .then(handleResponse)
      .catch(handleError);
  }

  deleteRecord(id) {
    const url = APIConstants.DELETE_RECORD.replace('{{id}}', id);
    return apiClient().delete(url).then(handleResponse).catch(handleError);
  }

  uploadAttachment(payload) {
    const url = APIConstants.UPLOAD_ATTACHMENT;
    return apiClient()
      .post(url, { AttachmentUploadRequest: payload })
      .then(handleResponse)
      .catch(handleError);
  }
}

export default new RecordBinderService();
